import { render } from "./OrderStatusesList.vue?vue&type=template&id=69183ddc"
import script from "./OrderStatusesList.vue?vue&type=script&lang=js"
export * from "./OrderStatusesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__